<template>
  <div class='content-body' v-loading="loading">
    <div class="headBoxTool">
      <div class="rigth-box" v-if="blankFlage==2">
        <span class="icon blue"><i class="icon-h5duan"></i></span>
        <div class="text-box">
          <div class="text1">管理H5页面模板</div>
          <div class="text2">您可以创建并自定义页面模板，或选择默认模板，复制模板链接至公众号菜单栏，可作为用户常用入口（模板内保险产品均为机构专属投保地址）</div>
        </div>
      </div>
      <div class="rigth-box" v-else>
        <span class="icon green"><i class="icon-xiaochengxu"></i></span>
        <div class="text-box">
          <div class="text1">管理小程序模板</div>
          <div class="text2">您可以创建并自定义页面模板，或选择默认模板，复制模板链接至公众号菜单栏，可作为用户常用入口（模板内保险产品均为机构专属投保地址）</div>
        </div>
      </div>
      <div class="btnList">
        <el-button class="backBtn" type="primary" @click="goback">返回</el-button>
      </div>
    </div>
    <div class="setbox clearfix">
      <div class="left" :class="{ xcx: blankFlage == 3 }">
        <div class="titleb clearfix" :class="{ xcx: blankFlage == 3 }">
          <span>{{ websiteName }}</span>
        </div>
        <!-- 默认模板展示 -->
        <div class="defaultbox">
          <div class="search">
            <div class="search-input-div">
              <img class="iconfont" :src="search_icon" />
              <input class="search-input" :disabled="true" placeholder="请输入产品名称" />
            </div>
          </div>
          <!-- 展示banner -->
          <div class="banner swiper-container swiper-container1" v-if="websiteBanners.length > 0">
            <div class="swiper-wrapper">
              <img class="swiper-slide" v-for="(item, index) in websiteBanners" :key="index" :src="item.bannerImg" alt="" />
            </div>
            <div class="swiper-pagination"></div>
          </div>
          <!-- 展示工具类 -->
          <div :class="['tools', toolList.length > 1 ? 'actives' : '']" v-if="toolList.length > 0">
            <div class="item" v-if="item.status != 2" v-for="(item, index) in toolList" :key="index">
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
          <!-- 展示产品分类 -->
          <div class="muns clearfix swiper-container" v-if="navBtnStyle == 1">
            <div class="swiper-wrapper">
              <div class="swiper-slide munItem" style="width: auto" :style="index == activeIndex?{'border-color':activethemeList.productTypeColor}:''" :class="{ active: index == activeIndex }"
                v-for="(item, index) in navBarList" :key="index">
                <span :style="index == activeIndex?{'color': activethemeList.productTypeColor}:''"> <i class="bt-line" v-if="index == activeIndex"
                    :style="index == activeIndex?{'background':activethemeList.productTypeColor}:''"></i>{{ item.name ? item.name : "分类名" }}</span>
              </div>
            </div>
          </div>
          <div class="qbzk clearfix" v-else>
            <div class="qbzkitem" style="width: auto" :style="index==activeIndex?{background:productBtnBackground}:''" v-for="(item, index) in navBarList" :key="index">
              <span :style="
                  index == activeIndex
                    ? { color:  activethemeList.productTypeColor }
                    :''
                ">{{ item.name ? item.name : "分类名" }}</span>
            </div>
          </div>
          <div class="qbzk clearfix" v-if="navBtnStyle == 1 && navBarChildList.length">
            <div class="qbzkitem" style="width: auto;background:#F2F2F5">
              <span style="color: #666666">全部</span>
            </div>
            <div class="qbzkitem" style="width: auto" v-for="(item, index) in navBarChildList" :key="index" :style="index==activeIndex2?{background:productBtnBackground}:''">
              <span :style=" index == activeIndex2? { color: activethemeList.productTypeColor }:''">{{ item.name ? item.name : "分类名" }}</span>
            </div>
          </div>
          <!-- 默认模板展示产品列表 -->
          <div class="content">
            <div class="proitem clearfix" v-for="(item, index) in ProductByTypeList" v-show="index < 3&& item.status != 2" :key="index">
              <div class="tag" v-if="item.tag" :style="{ background: activethemeList.productTagColor }">
                {{ item.tag }}
              </div>
              <div class="pic"><img :src="item.shortImg" alt="" /></div>
              <div class="word">
                <div class="name">{{ item.productName }}</div>
                <div class="desc" style="-webkit-box-orient: vertical">
                  {{ item.profile }}
                </div>
                <div class="bottom clearfix">
                  <div class="price">
                    <span><i class="prices">{{ item.price }}</i><span> 元起</span></span>
                  </div>
                  <div class="btns">
                    <span class="cp" v-if="item.buttonOne" :style="{
                        color: activethemeList.productBtnColor,
                        borderColor: activethemeList.productBtnColor
                      }">{{ item.buttonOne }}</span>
                    <span class="xq" v-if="item.buttonTwo" :style="{
                        color: activethemeList.productBtnColor,
                        borderColor: activethemeList.productBtnColor
                      }">{{ item.buttonTwo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box" v-show="blankFlage == 3">
          <div class="nav active">
            <img src="@static/images/webset/0-1.png" alt="">
            <div class="text">首页</div>
          </div>
          <div class="nav">
            <img src="@static/images/webset/1-0.png" alt="">
            <div class="text">我的</div>
          </div>
        </div>
      </div>
      <!-- 修改默认模板 -->
      <div class="right">
        <div class="bt clearfix">
          <div class="lefts">
            <span class="btspan">页面标题</span>
            <el-popover popper-class="phoneSetPopOver" placement="right" width="300" trigger="hover">
              <img class="hoverImg" src="@static/images/Template1_xcx.png" v-if="blankFlage == 3" alt="" />
              <img class="hoverImg" src="@static/images/Template1.png" v-else alt="" />
              <span class="wh" slot="reference">
                <i class="icon-wenhao1"></i>
              </span>
            </el-popover>
          </div>
          <div class="rights">
            <el-form>
              <el-form-item>
                <el-input v-model="websiteName" placeholder="页面标题" maxlength="12" size="small"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="colors">
          <div class="content clearfix">
            <div class="lefts">
              <span class="btspan">页面配色</span>
            </div>
            <div class="colorsc claerfix">
              <div class="item" v-for="(item, index) in themeList" :key="index" @click="themeIdChange(item.id)" :style="{ background: item.mainColor }">
                <img v-show="themeId ? item.id == themeId : index == 0" src="@static/images/selected.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="wx clearfix">
          <div class="title lefts">
            <span class="btspan">微信分享设置</span>
            <el-popover popper-class="phoneSetPopOver" placement="right" width="300" trigger="hover">
              <img class="hoverImg" src="@static/images/Template5_xcx.png" v-if="blankFlage == 3" alt="" />
              <img class="hoverImg" src="@static/images/Template5.png" alt="" v-else />
              <span class="wh" slot="reference"><i class="icon-wenhao1"></i></span>
            </el-popover>
          </div>
          <div class="wxdesc clearfix rights">
            <div class="wxContent">
              <el-input type="textarea" :rows="2" placeholder="分享描述……" v-model="wechatShareDescribe">
              </el-input>
            </div>
          </div>
        </div>
        <div class="wx clearfix" v-show="blankFlage != 3">
          <div class="lefts">
            <span class="btspan">分享图标</span>
          </div>
          <div class="wxpic clearfix rights">
            <div class="wxContent">
              <el-upload class="avatar-uploader" :class="{hasImg:wechatShareIcon}" :action="$config.api_root + '/resmgr/upload'" :show-file-list="false" :on-success="handleAvatarSuccessMobile"
                :before-upload="beforeAvatarUpload">
                <img v-if="wechatShareIcon" :src="wechatShareIcon" class="avatar" />
                <span v-else><i class="iconfont icon-jia"></i>添加</span>
              </el-upload>
            </div>
            <div class="desc">图片尺寸建议为100*100或以上</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn">
      <el-button class="org-btn" @click="save">保存</el-button>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  data: () => ({
    activeIndex: 0,
    activeIndex2: '',
    loading: false,
    blankFlage: '', // 1 pc;2 H5; 3 小程序
    websiteName: '', //网站标题
    websiteBanners: [], //banner数组
    wechatShareIcon: '', //微信分享logo
    wechatShareDescribe: '', //分享描述
    websiteId: '', //网站id
    themeList: '', // 主题配色
    themeId: '', // 配色id
    activethemeList: '', // 选中的配色
    navBtnStyle: '1', // 产品分类类型，1含子分类， 其他不含子分类
    search_icon: require('@/static/images/searchIcon.png'),
    curNavData: {},
    toolList: [{ name: '' }],
    navBarList: [{ name: '' }], //导航栏
    navBarChildList: [],
    ProductByTypeList: [],
    urlWebsiteId: '',
  }),
  components: {},
  created() {
    this.websiteId = this.$route.query.websiteId
    this.blankFlage = this.$route.query.websiteType
    this.phoneQuery()
  },
  computed: {
    productBtnBackground() {
      return this.$tools.colorRgb(this.activethemeList.productTypeColor)
    },
  },
  methods: {
    goback() {
      history.go(-1)
    },
    phoneQuery() {
      this.loading = true
      //网站数据查询
      this.$http({
        url: '/master/website/query',
        type: 'put',
        params: {
          websiteId: this.websiteId,
          type: this.blankFlage == 3 ? 3 : 2, //pc-1  移动端-2
        },
      })
        .then((res) => {
          this.loading = false
          this.websiteName = res.data.websiteName
          this.websiteBanners = res.data.websiteBanners
          this.wechatShareIcon = res.data.wechatShareIcon
          this.wechatShareDescribe = res.data.wechatShareDescribe
          this.themeList = res.data.themeList
          this.themeId = res.data.themeId
          this.urlWebsiteId = res.data.id
          if (this.themeId) {
            for (var i = 0; i < this.themeList.length; i++) {
              if (this.themeList[i].id == this.themeId) {
                this.activethemeList = this.themeList[i]
              }
            }
          } else {
            this.activethemeList = this.themeList[0]
          }
          this.navBtnStyle = res.data.navBtnStyle + ''
          this.queryToolbar()
          this.queryCustomProductType('', (_) => {
            if (this.curNavData.id) {
              this.queryCustomProductByType(this.curNavData.id)
            }
          })
          this.$nextTick(() => {
            new Swiper('.swiper-container1', {
              spaceBetween: 30,
              pagination: {
                el: '.swiper-pagination',
              },
            })
          })
        })
        .catch((e) => {
          this.loading = false
        })
    },
    //产品相关
    queryCustomProductByType(id) {
      var _datas = {
        status: '1',
        customProductTypeId: id,
        websiteId: this.urlWebsiteId,
      }
      if (this.blankFlage == 3) {
        _datas.isSupportWebapp = 1
      }
      this.$http({
        url: '/master/custom/queryCustomProductByType',
        type: 'put',
        params: _datas,
      }).then((data) => {
        this.ProductByTypeList = data.data
      })
    },
    save() {
      //更新网站数据
      this.$http({
        url: '/master/website/update',
        type: 'put',
        params: {
          websiteName: this.websiteName, // 页面标题
          websiteBanners: this.websiteBanners, // banner
          websiteType: this.blankFlage == 3 ? 3 : 2, //pc-1  移动端为2
          wechatShareIcon: this.wechatShareIcon, //微信分享logo
          wechatShareDescribe: this.wechatShareDescribe, // 分享描述
          id: this.urlWebsiteId,
          themeId: this.themeId,
          navBtnStyle: this.navBtnStyle * 1,
        },
      })
        .then((data) => {
          if (data.httpCode == 200) {
            this.$message.success('保存成功')
          }
        })
        .catch((e) => {})
    },
    //改变主题色
    themeIdChange(id) {
      this.themeId = id
      for (var i = 0; i < this.themeList.length; i++) {
        if (this.themeList[i].id == this.themeId) {
          this.activethemeList = this.themeList[i]
        }
      }
    },
    //导航栏查询
    queryCustomProductType(parentId, callback) {
      this.$http({
        url: '/master/custom/queryCustomProductType',
        type: 'put',
        params: {
          websiteId: this.urlWebsiteId,
          parentId: parentId,
        },
      }).then((res) => {
        if (!res.data || res.data.length == 0) {
          this.navBarChildList = []
          callback && callback()
          return
        }
        if (parentId) {
          this.navBarChildList = res.data
          if (
            this.activeIndex2 != -1 &&
            this.navBarChildList[this.activeIndex2]
          ) {
            this.curNavData = this.navBarChildList[this.activeIndex2]
          }
          callback && callback()
        } else {
          this.navBarList = res.data
          if (this.navBarList[this.activeIndex]) {
            this.activeIndex = this.activeIndex
          } else if (this.navBarList[this.activeIndex - 1]) {
            this.activeIndex = this.activeIndex - 1
          } else if (this.navBarList[this.activeIndex + 1]) {
            this.activeIndex = this.activeIndex + 1
          }
          if (this.navBarList.length) {
            this.curNavData = this.navBarList[this.activeIndex]
            this.parentNav = this.curNavData
            if (this.navBtnStyle == 1) {
              this.queryCustomProductType(this.curNavData.id, callback)
            } else {
              callback && callback()
            }
          }
        }
        this.$nextTick(() => {
          new Swiper('.muns', {
            slidesPerView: 'auto',
            spaceBetween: 30,
          })
        })
      })
    },
    //工具栏查询 status 1通过 2驳回 3审核中
    queryToolbar() {
      this.$http({
        url: '/master/custom/queryToolbar',
        type: 'put',
        params: {
          websiteId: this.urlWebsiteId,
        },
      }).then((res) => {
        this.toolList = res.data
      })
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
    handleAvatarSuccessMobile(res, file) {
      this.wechatShareIcon = res.data[0].wwwurl
    },
  },
}
</script>
<style lang='scss' scoped>
@import './editDefTempalte.scss';
</style>